import { css, cx } from "@emotion/css"
import { standardScrollBar } from "../../styles"

type TableRootLayoutProps = {
  children: React.ReactNode
  isTable?: boolean
}

export function RootLayout({ children, isTable }: TableRootLayoutProps) {
  return (
    <div
      className={cx(standardScrollBar.root, styles.tableContainer)}
      style={{
        borderRadius: isTable ? "0px 0px 20px 20px" : "20px 20px 0px 0px",
        padding: !isTable ? "30px 32px" : "32px",
      }}
    >
      <div style={{ width: "inherit" }} className={styles.tables}>
        {children}
      </div>
    </div>
  )
}
const styles = {
  tableContainer: css`
    display: flex;
    width: auto;
    flex-direction: column;
    text-align: center;
    flex-wrap: wrap;
    justify-content: center;
    background-color: var(--extra-dark-grey-2);
    border-radius: 20px 20px 0px 0px;
    overflow-y: hidden;
    overflow-x: auto;
  `,
  tables: css`
    align-self: center;
    justify-self: center;
  `,
}
